import incident from './incident';
import errors from './errors';
import crmTicket from './crmTicket';
import testEmail from './testEmail';
import chats from './chats';
import phoneNumbers from './phoneNumbers';
import countries from './countries';
import bufferPhoneNumbers from './bufferPhoneNumbers';
import messaging from './messaging';
import tenantModules from './admin';
import messagingDashboard from './messagingDashboard';
import integration from './integration';
import connectWiseTicket from './connectWiseTicket';
import common from './common';
import notificationGroups from './notificationGroups';
import teamsConnections from './teamsConnections';
import crm from './crm';
import treeView from './treeView';
import optIn from './optIn';
import extraResources from './billing';
import fileUpload from './fileUpload';
import ticketCreationTemplates from './ticketCreationTemplates';
import kaseyaTicket from './kaseyaTicket';
import autotaskTicket from './autotaskTicket';
import liveChats from './liveChats';
import chatBots from './chatBots';
import clientPortals from './clientPortalAdmin';
import clientPortalDefaults from './clientPortalDefaults';
import clientPortalDefaultsMapping from './clientPortalDefaultMapping';
import issueTypes from './issueTypes';
import secureData from './secureData';
import smsCampaignGroups from './smsCampaigns';
import auth from './auth';
import secureDataSettings from './secureDataSettings';
import createTicket from './createTicket';
import verificationSettings from './verificationSettings';
import optInSettings from './optInSettings';
import outgoingMail from './outgoingMail';
import helpdeskAi from './helpdeskAI';
import microsoft from './microsoft';
import dynamicCrmContacts from './dynamicCrmContacts';
import twilioAccounts from './twilioAccounts';
import wildCardDomains from './wildcardDomains';
import publicApiKeys from './publicApiKey';

export default {
  incident,
  errors,
  crmTicket,
  testEmail,
  chats,
  phoneNumbers,
  countries,
  bufferPhoneNumbers,
  messaging,
  tenantModules,
  messagingDashboard,
  integration,
  connectWiseTicket,
  common,
  notificationGroups,
  teamsConnections,
  crmData: crm,
  treeView,
  optIn,
  extraResources,
  fileUpload,
  ticketCreationTemplates,
  kaseyaTicket,
  autotaskTicket,
  liveChats,
  chatBots,
  clientPortals,
  clientPortalDefaults,
  clientPortalDefaultsMapping,
  issueTypes,
  secureData,
  smsCampaignGroups,
  auth,
  secureDataSettings,
  createTicket,
  verificationSettings,
  optInSettings,
  outgoingMail,
  helpdeskAi,
  microsoft,
  dynamicCrmContacts,
  twilioAccounts,
  wildCardDomains,
  publicApiKeys,
};
